<!--suppress JSAnnotator -->
<template>
    <div v-if="contact" class="modal-card view-contact-modal-card view-contact-modal">
        <header class="modal-card-head">
            <p class="modal-card-title">View Contact</p>
        </header>
        <section class="modal-card-body">
            <div class="columns">
                <div class="column is-10">
                    <p><strong>Name: </strong> <span>{{ $filters.valueOrDefault(contact.full_name) }}</span></p>
                    <p><strong>Telephone:</strong> <span>{{ $filters.valueOrDefault(contact.telephone) }}</span></p>
                    <p><strong>Mobile:</strong> <span>{{ $filters.valueOrDefault(contact.mobile) }}</span></p>
                    <p><strong>Fax:</strong> <span>{{ $filters.valueOrDefault(contact.fax) }}</span></p>
                    <p><strong>Email:</strong> <span>{{ $filters.valueOrDefault(contact.email) }}</span></p>
                    <p><strong>Address 1:</strong> <span>{{ $filters.valueOrDefault(contact.address_1) }}</span></p>
                    <p><strong>Address 2:</strong> <span>{{ $filters.valueOrDefault(contact.address_2) }}</span></p>
                    <p><strong>City:</strong> <span>{{ $filters.valueOrDefault(contact.city) }}</span></p>
                    <p><strong>State:</strong> <span>{{ $filters.valueOrDefault(contact.state) }}</span></p>
                    <p><strong>Zip:</strong> <span>{{ $filters.valueOrDefault(contact.zip) }}</span></p>
                    <p><strong>Lead Owner:</strong> <span>{{ $filters.valueOrDefault(userNameById(contact.lead_owner)) }}</span></p>
                    <p><strong>Proposal count:</strong> <span>{{ contactProposalsByContactId(contact.id).length }}</span></p>
                    <p><strong>Project count:</strong> <span>{{ contactProjectsByContactId(contact.id).length }}</span></p>
                </div>
                <div class="column">
                    <o-button type="is-light" icon-left="edit" @click="isContactModalActive = true">Edit contact</o-button>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <o-tabs type="is-boxed">
                        <o-tab-item label="Projects">
                            <o-table
                                v-if="isProjectsTableVisible"
                                :data="contactProjectsByContactId(contact.id)"
                                :bordered="table.bordered"
                                :striped="table.striped"
                                :narrowed="table.narrowed"
                                :checkable="table.checkable"
                                :loading="table.loading"
                                :mobile-cards="table.mobileCards"
                                :paginated="table.paginated"
                                :per-page="table.perPage"
                                :pagination-simple="table.paginationSimple"
                                :selected.sync="selected"
                                :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"
                            >
                                <template>
                                    <template>
                                        <div v-for="col in projectColumns">
                                          <o-table-column
                                              #default="{ row }"
                                              :field="col.field"
                                              :label="col.field == 'actions' ? '' : col.label"
                                              :key="col.field"
                                              :sortable="col.sortable"
                                          >
                                            <project-column v-if="col.field != 'actions'" :field="col.field" :item="row" />

                                            <o-dropdown v-else="col.field == 'actions'" hoverable position="bottom-left" class="table-actions">
                                              <button class="button" slot="trigger">
                                                <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                                              </button>
                                              <o-dropdown-item has-link><router-link :to="{ name: 'projects.show', params: { slug: row.id } }">View</router-link></o-dropdown-item>
                                              <o-dropdown-item has-link><router-link :to="{ name: 'projects.edit', params: { slug: row.id } }">Edit</router-link></o-dropdown-item>
                                              <!--<o-dropdown-item has-link><a @click="openReplyModal(row.id)">Reply</a></o-dropdown-item>-->
                                              <!--<o-dropdown-item has-link><a @click="openReminderModal(row.id)">Set Reminder</a></o-dropdown-item>-->
                                              <!--<o-dropdown-item has-link v-if="isFollowed(row.id)"><a @click.prevent="unfollow(row)">Unfollow</a></o-dropdown-item>-->
                                              <!--<o-dropdown-item has-link v-else><a @click.prevent="follow(row)">Follow</a></o-dropdown-item>-->
                                            </o-dropdown>
                                          </o-table-column>
                                        </div>
                                    </template>
                                </template>

                                <div slot="empty" class="has-text-centered">
                                    This table is empty!
                                </div>

                                <div slot="bottom-left">
                                    <i class="fa fa-gear fa-2x" @click.prevent="openTableSettings('contact-projects')"></i>
                                </div>
                            </o-table>
                        </o-tab-item>
                        <o-tab-item label="Proposals">
                            <o-table
                                v-if="isProposalsTableVisible"
                                :data="contactProposalsByContactId(contact.id)"
                                :bordered="table.bordered"
                                :striped="table.striped"
                                :narrowed="table.narrowed"
                                :checkable="table.checkable"
                                :loading="table.loading"
                                :mobile-cards="table.mobileCards"
                                :paginated="table.paginated"
                                :per-page="table.perPage"
                                :pagination-simple="table.paginationSimple"
                                :selected.sync="selected"
                                :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"
                            >
                                <template>
                                    <template>
                                        <div v-for="col in proposalColumns">
                                          <o-table-column
                                              :field="col.field"
                                              :label="col.field === 'actions' ? '' : col.label"
                                              :key="col.field"
                                              :sortable="col.sortable"
                                              #default="{ row }"
                                          >
                                            <proposal-column v-if="col.field !== 'actions'" :item="row" :field="col.field" />

                                            <o-dropdown v-else hoverable position="bottom-left" class="table-actions">
                                              <button class="button" slot="trigger">
                                                <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                                              </button>

                                              <o-dropdown-item has-link>
                                                <router-link :to="{ name: 'proposals.show', params: { slug: row.id } }">View</router-link>
                                              </o-dropdown-item>
                                              <o-dropdown-item has-link>
                                                <router-link :to="{ name: 'proposals.edit', params: { slug: row.id } }">Edit</router-link>
                                              </o-dropdown-item>
                                            </o-dropdown>
                                          </o-table-column>
                                        </div>
                                    </template>
                                </template>

                                <div slot="empty" class="has-text-centered">
                                    This table is empty!
                                </div>

                                <div slot="bottom-left">
                                    <i class="fa fa-gear fa-2x" @click.prevent="openTableSettings('contact-proposals')"></i>
                                </div>
                            </o-table>
                        </o-tab-item>
                        <o-tab-item label="Tasks">
                            <o-table
                                v-if="isTasksTableVisible"
                                :data="tasksByContactId(contact.id)"
                                :bordered="table.bordered"
                                :striped="table.striped"
                                :narrowed="table.narrowed"
                                :checkable="table.checkable"
                                :loading="table.loading"
                                :mobile-cards="table.mobileCards"
                                :paginated="table.paginated"
                                :per-page="table.perPage"
                                :pagination-simple="table.paginationSimple"
                                :selected.sync="selected"
                                :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"
                            >
                                <template>
                                    <template>
                                        <div v-for="col in taskColumns">
                                          <o-table-column
                                              :field="col.field"
                                              :label="col.field == 'actions' ? '' : col.label"
                                              :key="col.field"
                                              :sortable="col.sortable"
                                              #default="{ row }"
                                          >
                                            <task-column v-if="col.field != 'actions'" :item="row" :field="col.field" />
                                          </o-table-column>
                                        </div>
                                    </template>
                                </template>

                                <div slot="empty" class="has-text-centered">
                                    This table is empty!
                                </div>

                                <div slot="bottom-left">
                                    <i class="fa fa-gear fa-2x" @click.prevent="openTableSettings('contact-tasks')"></i>
                                </div>
                            </o-table>
                        </o-tab-item>

                        <o-tab-item label="Licenses">
                            <p><strong>Licenses:</strong></p>

                            <table class="table is-fullwidth is-narrow is-hoverable is-striped">
                                <tbody>
                                <tr>
                                    <th></th>
                                    <th>#</th>
                                    <th>Exp. Date</th>
                                </tr>
                                <tr>
                                    <td class="has-text-weight-bold">TAX ID</td>
                                    <td>{{ contact.tax_id }}</td>
                                    <td>-</td>
                                </tr>

                                <tr v-for="(number, name) in contact.licenses">
                                    <td class="has-text-weight-bold">{{ name }}</td>
                                    <td>{{ $filters.valueOrDefault(number.value, '-') }}</td>
                                    <td>{{ $filters.valueOrDefault($filters.date(number.exp_date), '-') }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </o-tab-item>
                        <o-tab-item label="Credentials">
                        <o-field label="User Name" >
                            <o-input v-bind:value="contact.user_name" readonly />
                        </o-field>
                        <o-field label="Password" >
                            <o-input password-reveal type="password" placeholder="" v-bind:value="contact.password" readonly :class="'reveal-external'" />
                        </o-field>
                    </o-tab-item>
                    </o-tabs >
                </div>
            </div>
        </section>

        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
        </footer>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isContactModalActive" has-modal-card>
            <contact-modal :item="contact"/>
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isPreviewModalActive" class="preview-modal" has-modal-card>
            <preview-modal :file="currentPreviewFile"/>
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Table from './../../mixins/Table'
    import PreviewModal from './Preview'
    import ProjectColumn from './../../components/table-columns/Project'
    import ProposalColumn from './../../components/table-columns/Proposal'
    import TaskColumn from './../../components/table-columns/Task'

    export default {
        mixins: [Table],

        props: ['contact'],

        components: {
            PreviewModal,
            ProjectColumn,
            ProposalColumn,
            TaskColumn,
        },

        data () {
            return {
                isContactModalActive: false,
                isPreviewModalActive: false,
                currentPreviewFile: null,
                isTableSettingsModalActive: false,
                tableName: null,

                isTasksTableVisible: true,
                isProjectsTableVisible: true,
                isProposalsTableVisible: true
            }
        },

        mounted () {
            this.fetchContactById(this.contact.id)
        },

        methods: {
            ...mapActions(['fetchContactById']),

            openPreviewModal(proposal) {
                this.isPreviewModalActive = true
                this.currentPreviewFile = {
                    name: `Proposal #${proposal.number}`,
                    path: `${location.protocol}//${window.location.hostname}/proposals/${proposal.id}/pdf`,
                    mime: 'application/pdf',
                    generatedOnTheFly: true
                }
            },

            openTableSettings(table) {
                this.tableName = table
                this.isTableSettingsModalActive = true
            }
        },

        computed: {
            ...mapGetters([
                'contactProposalsByContactId',
                'contactProjectsByContactId',
                'tasksByContactId',
                'projectNameById',
                'userNameById',
                'boroughNameById',
                'tableColumnsBySlug',
            ]),

            projectColumns() {
                return this.tableColumnsBySlug('contact-projects')
            },

            proposalColumns() {
                return this.tableColumnsBySlug('contact-proposals')
            },

            taskColumns() {
                return this.tableColumnsBySlug('contact-tasks')
            },
        },

        watch: {
            projectColumns() {
                this.isProjectsTableVisible = false
                this.$nextTick(() => {
                    this.isProjectsTableVisible = true
                })
            },

            proposalColumns() {
                this.isProposalsTableVisible = false
                this.$nextTick(() => {
                    this.isProposalsTableVisible = true
                })
            },

            taskColumns() {
                this.isTasksTableVisible = false
                this.$nextTick(() => {
                    this.isTasksTableVisible = true
                })
            }
        }

    }
</script>
